import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import $ from 'jquery';
import 'popper.js';
import 'bootstrap';

class Modal extends PureComponent {
  modal = null;

  componentDidMount = () => {
    this.setOptions(this.props);
    this.bindEvents();
    this.toggleModal();
  };

  setOptions = ({ backdrop = true, keyboard = true, focus = true }) =>
    $(this.modal).modal({ backdrop, keyboard, focus, show: false });

  bindEvents = () => {
    $(this.modal).on(
      'hidden.bs.modal',
      (e) => this.props.show && this.props.handleClose && this.props.handleClose(e)
    );
    // Once visible: content that measures itself (a canvas) needs its real size.
    $(this.modal).on('shown.bs.modal', (e) => this.props.onShown && this.props.onShown(e));
  };

  componentWillUnmount = () => $(this.modal).off('hidden.bs.modal shown.bs.modal');

  componentWillUpdate = (nextProps) => this.setOptions(nextProps);

  componentDidUpdate = (prevProps) => prevProps.show !== this.props.show && this.toggleModal();

  toggleModal = () => (this.props.show ? $(this.modal).modal('show') : $(this.modal).modal('hide'));

  render = () => {
    return (
      <div
        ref={(element) => (this.modal = element)}
        className={classnames('modal fade', this.props.extraClassName)}
      >
        <div
          className={classnames('modal-dialog', {
            [`modal-${this.props.size}`]: this.props.size,
            'modal-dialog-scrollable': this.props.scrollable,
          })}
        >
          <div className="modal-content">{this.props.children}</div>
        </div>
      </div>
    );
  };
}

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  extraClassName: PropTypes.string,
  backdrop: PropTypes.bool,
  keyboard: PropTypes.bool,
  focus: PropTypes.bool,
  // Bootstrap 4.5 sizes; without it the dialog keeps its fixed 500 px.
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  scrollable: PropTypes.bool,
  onShown: PropTypes.func,
};

export default Modal;



// WEBPACK FOOTER //
// src/modules/common/components/Modal.js